<mat-toolbar color="warn" style="height: 40px;">
  <button mat-stroked-button color="primary" (click)="sendOpenedEmailAll()">
    Send "Booth Opened" Email to Approved
  </button>
  <span class="example-spacer"></span>
  <mat-select style="height: 10px;"  (selectionChange)="changeState($event.value)" placeholder="Select filter">
    <mat-option value="ALL" selected>
      Show all
    </mat-option>
    <mat-option value="APPLIED">
      Show applications
    </mat-option>
    <mat-option value="APPROVED">
      Show approved only
    </mat-option>
    <mat-option value="DENIED">
      Show denied only
    </mat-option>
  </mat-select>
</mat-toolbar>

<table mat-table [dataSource]="filtered">
  <ng-container matColumnDef="org">
    <th mat-header-cell *matHeaderCellDef>Organization</th>
    <td mat-cell *matCellDef="let p">
      {{p.name}}
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Size</th>
    <td mat-cell *matCellDef="let p">
      {{p.type || "N/A"}}
    </td>
  </ng-container>
  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef>Owner</th>
    <td mat-cell *matCellDef="let p">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.owner.uuid}}/20"> &nbsp;
        {{p.owner.username}}
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="members">
    <th mat-header-cell *matHeaderCellDef>Members</th>
    <td mat-cell *matCellDef="let p">
      {{p.members.length}}
    </td>
  </ng-container>
  <ng-container matColumnDef="purchase_state">
    <th mat-header-cell *matHeaderCellDef>Purchase State</th>
    <td mat-cell *matCellDef="let p">
      {{p.purchaseState.state}}
    </td>
  </ng-container>
  <ng-container matColumnDef="build_state">
    <th mat-header-cell *matHeaderCellDef>Build State</th>
    <td mat-cell *matCellDef="let p">
      {{p.approvalState.state}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" routerLink="/booths/{{row.id}}"></tr>
</table>
